var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['notification mb-1', _vm.status, { 'is-active': _vm.show }]},[_c('span',{staticClass:"close",on:{"click":() => _vm.dismissNotification(_vm.id)}},[_vm._v("×")]),_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }